import { Injectable } from '@angular/core';
import { UntypedFormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { FieldConfigurationService } from '../service/field-configuration.service';

type XPathValidationTypes = '$value' | '$operator';

@Injectable({
    providedIn: 'root'
})
export class RuleValidators
{
    constructor(private fieldConfigurationService: FieldConfigurationService) { }

    /**
     * Configuration Field Name check if exists
     *
     * @param control Name control
     * @returns null if validation succeed or JSON object when validation failed.
     */
    public validateFieldConfigurationNameUnique(control: UntypedFormControl, previousFieldConfigurationName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && previousFieldConfigurationName !== control.value)
            {
                this.fieldConfigurationService.existsFieldConfigurationName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }

    /**
     * Xpath validation to make sure $value and $operator is being used when xpath not starting with /
     *
     * @param aType XPath validation type
     * @returns null if validation succeed or JSON object when validation failed.
     */
    public validateXpath(aType: XPathValidationTypes): ValidatorFn
    {
        return (control: AbstractControl): { [key: string]: any } | null =>
        {
            if ((control.value !== null) && (control.value.length > 0) && (control.value.substring(0, 1) !== '/'))
            {
                if (aType === '$value')
                {
                    return (control.value.indexOf(aType) < 0) ? { missingValue: true } : null;
                }
                else if (aType === '$operator')
                {
                    return (control.value.indexOf(aType) < 0) ? { missingOperator: true } : null;
                }
            }
            return null;
        };
    }
}
